import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
    name: 'dateFormat',
    standalone: true,
})
export class DateFormatPipe implements PipeTransform {

    /**
     * Returns the date formatted using the moment.js formatter
     * 
     * @param date a chosen Date
     * @param format the format to use
     * @returns a formatted string of the date
     */
    transform(date: Date, format: string): string {
        // We can't use Angular's default Date pipe as it's incompatible with moment's formatting.
        // Specifically moments use of "DD" format for days (12, 31 etc), Angular expects this to be "dd"
        return moment(date).format(format);
    }
}
